module.exports = __webpack_public_path__ + "img/rm_negatives.3bc88d90.svg";